const options = {
    use: true,
    position: 'left'
};
export default options;
